<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [hideOkButton]="!isAuthorized"
            [disabled]="!mapForm.form.valid"
            [title]="(data.isEditMode ? 'Edit' : 'Add') + ' NODE'">

  <form #mapForm="ngForm" autocomplete="off" class="nodes-dialog">
    <mat-form-field class="fullWidth">
      <mat-label>Name</mat-label>
      <input [(ngModel)]="data.selectedItem.name" matInput name="name" required>
      <mat-error>
        Name is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="fullWidth">
      <mat-label>Teams Role</mat-label>
      <mat-select [(ngModel)]="data.selectedItem.teamsRole" [disabled]="!data.isSupportsTeams && data.isEditMode" name="teamsRole">
        <mat-option *ngFor="let item of teamsRoleOptions" [value]="item.value">
          {{item.text}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <p *ngIf="data.selectedItem.productType === 'GW' && (data.selectedItem.teamsRole === 'REMOTE' || data.selectedItem.teamsRole === 'PROXY')"
      class="remote-teams-notice">
      Picking teams role for GW has no effect on the configuration
    </p>
    <p *ngIf="data.selectedItem.productType === 'HYBRID' && data.selectedItem.teamsRole === 'PROXY'"
       class="remote-teams-notice">
      Picking teams role for Hybrid other than Remote has no effect on the configuration
    </p>

    <mat-form-field class="fullWidth">
      <mat-label>Address</mat-label>
      <input [(ngModel)]="data.selectedItem.addressForGUI" [disabled]="data.isEditMode"
             matInput name="addressForGUI" required>
      <mat-error>
        Address is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-radio-group class="address-type" *ngIf="!data.isEditMode" [(ngModel)]="data.selectedItem.isIpAddressProvidedForGUI"
                     [ngModelOptions]="{standalone: true}">
      <div class="form-row">
        <div class="form-column">
          <mat-radio-button color="primary" [value]="true">IP Address</mat-radio-button>
        </div>
        <div class="form-column">
          <mat-radio-button color="primary" [value]="false">Hostname</mat-radio-button>
        </div>
      </div>
    </mat-radio-group>

    <mat-form-field class="fullWidth">
      <mat-label>Protocol</mat-label>
      <mat-select [(ngModel)]="data.selectedItem.transportType" name="transportType">
        <mat-option *ngFor="let item of transportTypeOptions" [value]="item.value">
          {{item.text}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="fullWidth">
      <mat-label>Routing server group</mat-label>
      <mat-select [(ngModel)]="data.selectedItem.routingServerGroupId" name="routingServerGroupId">
        <mat-option></mat-option>
        <mat-option *ngFor="let item of data.routingServerGroups" [value]="item.id">
          {{item.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="isTopologyGroups()" class="fullWidth">
      <mat-label>Resource Groups</mat-label>
      <div class="resource-groups-names">
      <mat-chip-list aria-label="Resource Groups" disabled>
        <mat-chip *ngFor="let group of generateTopologyGroupsInfo(data.selectedItem.topologyGroups)"
                  [selectable]="false" class="resource-groups-names-chip" title="{{group}}">
          {{group}}
        </mat-chip>
      </mat-chip-list>
      </div>
    </mat-form-field>

    <div class="node-edit-legacy-warning">
      <span *ngIf="data.isLegacyNode && !isLegacyGroup() && data.isEditMode">
        The node has an old software version which doesn't support the picked routing server group
      </span>
    </div>
    <div class="node-add-no-server-warning">
      <span *ngIf="!data.selectedItem.routingServerGroupId || data.selectedItem.routingServerGroupId == -1">
        The node will be unrouteable as no routing server group was picked
      </span>
    </div>
    <br/>

    <ng-container *ngIf="isAuthorized">
      <ac-line-separator [(collapsed)]="isCollapsed" [isCollapsible]="true" title="Credentials">
        <div class="node-dialog-advanced-configuration">
          <mat-form-field class="fullWidth">
            <mat-label>
              <span class="device-before-arrow">Configurator</span><i aria-hidden="true"
                                                                      class="fa fa-long-arrow-right fa-lg"></i><span
              class="device-after-arrow">Node</span>
            </mat-label>
            <mat-select [(ngModel)]="data.selectedItem.credentialsId" name="credentialsId">
              <mat-option *ngFor="let item of data.nodeCredentials" [value]="item.id">
                {{item.description}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="fullWidth">
            <mat-label>
              <span class="device-before-arrow">Node</span><i aria-hidden="true"
                                                              class="fa fa-long-arrow-right fa-lg"></i><span
              class="device-after-arrow">Configurator</span>
            </mat-label>
            <mat-select [(ngModel)]="data.selectedItem.operatorId" name="operatorId">
              <mat-option *ngFor="let item of data.nodeUsers" [value]="item.id">
                {{item.userName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ac-line-separator>
    </ng-container>
  </form>
</arm-dialog>
